import React from 'react';
import TeamMemberTasks from '../../Components/TMComponents/TeamMemberTasks';

const TMDashboard: React.FC = () => {
  return (
    <div>

      <TeamMemberTasks />
    </div>
  );
};

export default TMDashboard;
